import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const requireModule = require.context("./modules", false, /\.js$/);
const modules = {};

requireModule.keys().forEach(fileName => {
  const moduleName = fileName.replace(/(\.\/|\.js)/g, "");
  modules[moduleName] = {
    // namespaced: true,
    ...requireModule(fileName).default
  };
});

export default new Vuex.Store({
  strict: true,
  state: {
    activityNo: "COINCOIN6M"
  },
  mutations: {},
  actions: {},
  modules
});
